import { getConfig } from "../../common/env-config";

const { baseUrl } = getConfig();

export const getAccessToken = async (agentId) => {
    try {
        const response = await fetch(`${baseUrl}/internal/ec-leads/external-agent-token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: agentId
            })
        });

        const data = await response.json();
        if (response.ok) {
            localStorage.setItem('email', 'externalagent@gmail.com');
            localStorage.setItem("accessToken", data.accessToken);
            localStorage.setItem("userId", data.userId);
        } else {
            console.error('Error fetching access token: ', data.message);
        }
    } catch (error) {
        console.error('Error fetching access token: ', error);
    }
};
